import CommonIFrame from '../atoms/CommonIFrame';

const PriceChangeDecomposition = () => {
    return (
        <CommonIFrame
            src="https://priafhefihf-a23840-aihedoiwshdi.lovable.app"
            title="Price Change Decomposition"
        />
    );
};

export default PriceChangeDecomposition;
